
import React from 'react';
import { useTranslation } from 'react-i18next';
import { URL_BARCODE, URL_WOOD_EXPORT } from '../../constance/urls';
import useSearchItem from '../../hooks/useSeatchItem';
import { defaultBarcodeDetail, defaultExportItemDetail, PACKING_TYPE } from '../../constance/dataTypes';
import { Toast } from '../../utils/Toast';
import { POST } from '../../utils/HttpClient';
import * as _ from 'lodash';
import { Alert, Input, Modal, Button, Select, Form, AutoComplete, Row, Col } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import { useDebounce } from 'use-debounce';
import ColorButton from '../common/ColorButton';
import { GREEN } from '../../constance/color';


export default function AddExportBarcodeModal(props) {
  const {
    open,
    onClose,
    fetchData,
    saleLineTarget,
  } = props;

  const { t } = useTranslation();
  const [form] = Form.useForm();
  const barcodeList = useSearchItem({ url: URL_BARCODE.BARCODE, title_render: 'barcode_no' })
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const barcode = Form.useWatch('barcode_no',form)
  const [debouncedText] = useDebounce(barcode, 500);
  const [barcodeForm] = Form.useForm();
  
  React.useEffect(() => {
    barcodeList.fetchData()
  }, [])

  React.useEffect(() => {
    if (debouncedText) {
      barcodeList.fetchData({ search: debouncedText })
    }
  }, [debouncedText])

  const closeModal = () => {
    fetchData();
    onClose();
  }

  const packingTypeChoices = Object.entries(PACKING_TYPE).map(
    ([_, value]) => ({ id: value, value: value, text: t(`export_transactions.packing_types.${value}`) })
  )

  const handleSubmit = async () => {
    setErrorMessages(null);
    setIsLoading(true);
    try {
      const values = await form.validateFields();      
      let params = { ...values };
      if (!values.id) {
        const barcodeResponse = await POST(URL_BARCODE.BARCODE_PARSING, barcodeForm.getFieldsValue())
        params['barcode'] = _.get(barcodeResponse, 'data.id', null)
      }
      await POST(URL_WOOD_EXPORT.EXPORT_ITEM, params)
      Toast.success(t('success'))
      closeModal();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setIsLoading(false);
    }
  }

  React.useEffect(() => {
    if (open) {
      setErrorMessages(null);
      form.resetFields();
    }
  }, [open])

  return (

    <Modal
      open={open}
      onCancel={closeModal}
      title={t('export_transactions.add')}
      footer={[
        <Button
          icon={<CloseOutlined />}
          color='default'
          variant='filled'
          loading={isLoading}
          onClick={onClose} >{t('cancel')}</Button>,
        <ColorButton
          icon={<PlusOutlined />}
          type='primary'
          override={GREEN}
          loading={isLoading}
          onClick={handleSubmit}
        >{t('add')}</ColorButton>

      ]} >
      {errorMessages && <Alert type='error' message={errorMessages} />}
      <Form form={form} initialValues={{ ...defaultExportItemDetail, export_sale_line: saleLineTarget }} layout='vertical'>
        <Form.Item
          name={"barcode_no"}
          label={t('barcodes.barcode_id')}
          rules={[{ required: true, message: t('error_messages.validation.required') }]}>
          <AutoComplete
            options={barcodeList.response.map((barcode) => ({
              value: barcode.barcode_no,
              label: barcode.barcode_no,
              result: barcode,
            })) || []}
            notFoundContent={barcode ? t('no_data') : ""}
            onSelect={(v, { result }) => barcodeForm.setFieldsValue(result)}
          >
            <Input.Search placeholder={`${t('search')} ${t('barcodes.barcode_id')}...`} loading={barcodeList.isLoading} />
          </AutoComplete>
        </Form.Item>
        <Form.Item name={'export_sale_line'} hidden />
        <Row gutter={16}>
          <Col sm={24} md={24} lg={12} style={{ width: '100%' }}>
            <Form.Item
              name='packing_type'
              label={t('export_transactions.packing_type')}
            >
              <Select options={packingTypeChoices} />
            </Form.Item>
          </Col>
          <Col sm={24} md={24} lg={12} style={{ width: '100%' }}>
            <Form.Item
              name='humidity'
              label={t('export_transactions.humidity')}
              rules={[{ required: true, message: t('error_messages.validation.required') }]} >
              <Input placeholder={`${t('export_transactions.humidity')}...`} />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Form form={barcodeForm}>
        <Form.Item hidden name='id' />
        <Form.Item hidden name='barcode_no' />
        <Form.Item hidden name='wood_size_amount_map_list' />
      </Form>
      
    </Modal>

  )
}

